import DownloadIcon from '@mui/icons-material/GetApp'
import { useDataProvider, useNotify } from 'ra-core'
import { Button } from 'ra-ui-materialui'
import * as React from 'react'
import { useCallback } from 'react'
import { useListContext } from 'react-admin'
export const AdvancedExportButton = (props) => {
  const { resource, total, filterValues } = useListContext()
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const handleClick = useCallback(() => {
    dataProvider
      .export({ resource, filter: filterValues })
      .then(() => notify('mymove.notification.export.success'))
      .catch(() => notify('ra.notification.http_error', { type: 'error' }))
  }, [dataProvider, filterValues, notify, resource])

  return (
    <Button onClick={handleClick} label="ra.action.export" disabled={total === 0} {...props}>
      <DownloadIcon />
    </Button>
  )
}

export default AdvancedExportButton
